import { Grid, Skeleton } from '@mui/material';

export const TileSkeleton = (props: { tilesPerRow?: number }) => {
  return (
    <Grid
      container
      item
      xs={12}
      lg={6}
      xl={props.tilesPerRow ? 12 / props.tilesPerRow : 4}
      alignContent={'center'}
      justifyContent={'center'}
      padding={2}
    >
      <Skeleton height={'20em'} width={'95%'} sx={{ transform: 'unset' }} />
    </Grid>
  );
};
